import { gql } from "@apollo/client";

export const CHECK_SITE_INSTALLED = gql`
  query CheckSiteInstalled($sitePublicIds: [ID!]!) {
    siteInstalled(sitePublicIds: $sitePublicIds) {
      siteId
      isInstalled
      installedAt
    }
  }
`;

export const CHECK_CAMPAIGNS_INSTALLED = gql`
  query CheckCampaignsInstalled(
    $sitePublicId: ID!
    $campaignPublicIds: [ID!]!
  ) {
    campaignInstalled(
      sitePublicId: $sitePublicId
      campaignPublicIds: $campaignPublicIds
    ) {
      campaignId
      isInstalled
    }
  }
`;

export const CHECK_SITES_PUBLISHED = gql`
  query CheckSitesPublished($sitePublicIds: [ID!]!) {
    sitePublished(sitePublicIds: $sitePublicIds) {
      siteId
      publishedAt
      isPublished
    }
  }
`;

const TARGET_SEGEMENT_ITEM_FIELDS = gql`
  fragment TargetSegmentItem on TargetSegmentItem {
    campaignId
    userId
    engageable
    createdBy
    createdAt
    modifiedAt
    engagedAt
    properties
  }
`;

export const GET_TARGET_SEGMENT_BY_CAMPAIGN_ID = gql`
  ${TARGET_SEGEMENT_ITEM_FIELDS}
  query GetTargetSegmentByCampaignId($campaignPublicId: ID!) {
    targetSegmentByCampaignId(campaignPublicId: $campaignPublicId) {
      ...TargetSegmentItem
    }
  }
`;

export const UPDATE_TARGET_SEGMENT = gql`
  mutation UpdateTargetSegment(
    $sitePublicId: ID!
    $targetSegment: [TargetSegmentItemInput!]!
  ) {
    updateTargetSegment(
      sitePublicId: $sitePublicId
      targetSegment: $targetSegment
    )
  }
`;

export const DELETE_TARGET_SEGMENT = gql`
  mutation DeleteTargetSegment(
    $sitePublicId: ID!
    $targetSegmentIds: [TargetSegmentDeleteItemInput!]!
  ) {
    deleteTargetSegment(
      sitePublicId: $sitePublicId
      targetSegmentIds: $targetSegmentIds
    )
  }
`;
